import { render, staticRenderFns } from "./SendRoomNumber.vue?vue&type=template&id=34647381&"
import script from "./SendRoomNumber.vue?vue&type=script&lang=js&"
export * from "./SendRoomNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports